import { render, staticRenderFns } from "./RelatoriosPoliticaVendas.vue?vue&type=template&id=290513d4&scoped=true&"
import script from "./RelatoriosPoliticaVendas.vue?vue&type=script&lang=js&"
export * from "./RelatoriosPoliticaVendas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290513d4",
  null
  
)

export default component.exports